<template>
    <div class="search">
        <span class="search__label">{{ label }} <span id="asterics" v-if="required">&#42;</span></span>
        <div class="search__container">
            <input @input="searchValue" v-model.trim="currentValue" class="search__input" type="text">
            <button @click="select" class="search__select" type="button">
                <i :class="{ opened: isOpen, closed: !isOpen }" class="uk-icon-chevron-down"></i>
            </button>
        </div>
        <ul class="result-list" v-if="resultList.length">
            <li @click="getValue(e)" v-for="(e, i) in resultList" :key="i">{{ obj[e] }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        label: { type: String },
        required: { type: Boolean, default: false },
        obj: { type: Object },
        keys: { type: Array },
        value: { type: String }
    },
    data() {
        return {
            resultList: [],
            currentValue: ''
        }
    },
    computed: {
        isOpen() { return this.resultList.length > 0 }
    },
    methods: {
        select() {
            if(this.isOpen) {
                this.resultList = []
            } else {
                this.resultList = this.keys
            }
        },
        getValue(value) {
            this.resultList = []
            this.currentValue = this.obj[value]
            this.$emit('input', value)
        },
        searchValue() {
            if(!!this.currentValue) {
                this.resultList = this.keys.filter(e => this.obj[e].toLowerCase().includes(this.currentValue.toLowerCase()))
            } else {
                this.select()
            } 
        },
        clearValue() {
            this.currentValue = ''
            this.resultList = []
        }
    },
    watch: {
        value() {
            this.currentValue = this.obj?.[this.value] ?? ''
        }
    }
}
</script>

<style lang="sass" scoped>
    .search
        position: relative
        width: 100%
       
        &__label
            display: inline-block
            font-weight: 400
            font-size: 14px
        &__container
            display: flex
            justify-content: space-between
            align-items: center
            min-height: 30px
            border-radius: 3px
            padding: 4px 8px
            border: 1px solid #b8b8b8
            box-shadow: none
            text-align: left
            margin-top: 2px
        &__input
            width: 100%
            border: none
        &__select
            padding: 1px
            display: flex
            justify-content: center
            align-items: center
            border: none
            background: none
            cursor: pointer
            i
                transition: transform .5s
            i.opened
                transform: rotate(-180deg)
            i.closed
                transform: rotate(0deg)    
        .result-list
            margin: 0
            padding: 0 10px
            width: 100%
            max-height: 200px
            position: absolute
            left: 0
            background: #fff
            border-radius: 4px
            overflow-y: scroll
            box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4)
            li
                cursor: pointer
                width: 100%
                &:hover
                    background: rgba(0, 0, 0, 0.1)
        
</style>